import React from 'react'
import MetaTags from 'components/MetaTags'

import Layout from 'layouts/Layout'
import { ScrollProvider } from 'components/ScrollContext'
import TrialSlideshow from 'components/products/TrialSlideshow'

export default () => (
  <Layout hideHeader hideFooter hideWarning>
    <MetaTags
      title="Pod Vape System Starter Bundle Kit | Vuse Canada"
      description="Customize your own vaping starter bundle and save 40%"
    />
    <ScrollProvider initialStep="#step-1" categories={['#step-2', '#step-3', '#step-4']}>
      <TrialSlideshow />
    </ScrollProvider>
  </Layout>
)
